import { Col, Form, Input, Modal, Row, Select } from "antd";
import React from "react";
import { DEPARTMENT } from "../../../../constants/option";

interface EditUserModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: (roleId: number) => void;
  initialValues?: any; // Add initialValues prop to accept initial data for editing
}

const EditUserModalProps: React.FC<EditUserModalProps> = ({
  visible,
  onCancel,
  onConfirm,
  initialValues,
}) => {
  const [form] = Form.useForm();
  const handleEditConfirmed = async () => {
    try {
      const formData = await form.validateFields();
      formData.user_id = initialValues.user_id;
      const { role } = formData;
      if (!role || role === "0") {
        console.error("กรุณาเลือกแผนก!");
        return;
      }

      onConfirm(parseInt(role, 10));
      onCancel();
    } catch (error) {
      console.error("Error updating record:", error);
    }
  };

  React.useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues, form]);

  return (
    <Modal
      title="Confirm Delete"
      visible={visible}
      onOk={handleEditConfirmed}
      onCancel={onCancel}
      width="70vw" // Set the width to 80% of the viewport width
    >
      <Form form={form} onFinish={onConfirm} initialValues={initialValues}>
        <Row gutter={16}>
          <Col xs={24} sm={12} md={11}>
            <Form.Item
              label="Username"
              labelCol={{ xs: { span: 24 }, sm: { span: 8 } }} // Adjust the label width for different screen sizes
              wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }} // Adjust the input field width for different screen sizes
              name="username"
              rules={[{ required: true, message: "กรุณาใส่ username!" }]}
            >
              <Input placeholder="กรุณาใส่ username" disabled={true} />
            </Form.Item>
            <Form.Item
              label="ชื่อจริง"
              labelCol={{ xs: { span: 24 }, sm: { span: 8 } }} // Adjust the label width for different screen sizes
              wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }} // Adjust the input field width for different screen sizes
              name="firstname"
              rules={[{ required: true, message: "กรุณาใส่ชื่อจริง!" }]}
            >
              <Input placeholder="กรุณาใส่ ชื่อจริง" disabled={true} />
            </Form.Item>
            <Form.Item
              label="ชื่อเล่น"
              labelCol={{ xs: { span: 24 }, sm: { span: 8 } }} // Adjust the label width for different screen sizes
              wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }} // Adjust the input field width for different screen sizes
              name="nickname"
              rules={[{ required: true, message: "กรุณาใส่ชื่อเล่น!" }]}
            >
              <Input placeholder="กรุณาใส่ ชื่อเล่น" disabled={true} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12}>
            <Form.Item
              label="นามสกุล"
              labelCol={{ xs: { span: 24 }, sm: { span: 8 } }} // Adjust the label width for different screen sizes
              wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }} // Adjust the input field width for different screen sizes
              name="lastname"
              rules={[{ required: true, message: "กรุณาใส่นามสกุล!" }]}
            >
              <Input placeholder="กรุณาใส่ นามสกุล" disabled={true} />
            </Form.Item>
            <Form.Item
              label="ระดับหน้าที่"
              labelCol={{ xs: { span: 24 }, sm: { span: 8 } }} // Adjust the label width for different screen sizes
              wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }} // Adjust the input field width for different screen sizes
              name="role"
              rules={[
                { required: true, message: "กรุณาเลือกแผนก!" },
                () => ({
                  validator(_, value) {
                    if (value !== 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject("กรุณาเลือกแผนก!");
                  },
                }),
              ]}
            >
              <Select placeholder="== กรุณาเลือกหน้าที่ ==" style={{ textAlign: "center" }}>
                {DEPARTMENT.map((item) => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditUserModalProps;
